import { useApi } from '@hooks/useApi';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@utils/consts';
import { CardAuth } from '@services/global/cardAuths/types';
import { MetaData } from '@root/globalTypes';
import { useCheckUserPermissions } from '@hooks/checkUserPermisions';

interface CardAuthsResponse {
  cardAuths: CardAuth[];
  meta: MetaData | undefined;
}

export function useGetMerchantCardAuths(merchantId: string) {
  const { isLogged } = useCheckUserPermissions();
  const { query } = useApi();

  const { data, isPending } = useQuery<CardAuthsResponse>({
    queryKey: [...queryKeys.cardAuths],
    queryFn: (): Promise<CardAuthsResponse> =>
      query({
        path: `v1/acquirer/merchants/${merchantId}/3ds`,
      }),
    placeholderData: (previousValue) => previousValue,
    enabled: isLogged,
  });

  return {
    data: data?.cardAuths || [],
    meta: data?.meta || undefined,
    isPending,
  };
}
